export enum PaginationTypeEnums {
  LIMIT = 10,
}

export enum MessagesPaginationTypesEnums {
  LIMIT = 25,
}
